module.exports = __webpack_public_path__ + "img/datos_empleado.7f995b1d.svg";